"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BattleTurnStartMessage = void 0;
var common_1 = require("@timeflies/common");
var joi = __importStar(require("joi"));
var message_1 = require("../../message");
exports.BattleTurnStartMessage = message_1.createMessage('battle/turn-start', joi.object({
    characterId: common_1.characterIdSchema,
    startTime: joi.number().required().integer().min(0),
    roundIndex: joi.number().required().integer().min(0),
    turnIndex: joi.number().required().integer().min(0)
}));
